module.exports = __webpack_public_path__ + "static/media/profile.94c14dc4.jpg";